import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ACCESS_DENIED_MSG, CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ERR_MSG, CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { ADD_GRN_PRODUCTS_API, RETRIEVE_ACTIVE_PRODUCT_LIST, RETRIEVE_SPECIFC_BRANCH_STORAGE_LIST_BY_STATUS_ID_API } from '../../../../../../api/api_data';
import { fail_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, success_retrieve_warehouse_storages_list } from '../../../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { useSelector } from 'react-redux';
import { messageToast, rSelectMapFun } from '../../../../../../utils/Utils';
import { Block, BlockBetween, BlockHead, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, RSelect } from '../../../../../../components/Component';
import { Alert, Row } from 'reactstrap';
import { getSelectedOption, retreive_rSelectVariables } from '../../../../../../utils/functionalUtils';
import TextInput from '../../../../../components/inputs/TextInput';
import ModalConfirmCancel from '../../modal_confirm_cancel/ModalConfirmCancel';
import { fail_add_goods_received_products, loading_add_goods_received_products, reset_add_goods_received_products, success_add_goods_received_products } from '../../../../../../reducers/dashboard_reducers/goods_received/add_goods_received_products_Slice';

const initialState = { product_id: "", product_type: "", product: "", warehouse_storage_id: "", warehouse_storage: "", total_capacity_selected_measurement: "", total_capacity_in_mt: "", warehouse_storage: "", packet_size: "", product_type_id: "", density_weight: "", base_weight: "" };
const UNKNOWN_PACKET_SIZE = "Unknown";
const UNKNOWN_PACKET_SIZE_OPTION = { label: UNKNOWN_PACKET_SIZE, value: UNKNOWN_PACKET_SIZE };

const isUnknownPacketSize = (packetSize) => String(packetSize || "").toLowerCase() === UNKNOWN_PACKET_SIZE.toLowerCase();

const isGrainProduct = (productType = "", product = "") =>
  [productType, product].some((value) => String(value || "").toLowerCase().includes("grain"));

const getPacketSizeOptions = (packetSizes = [], allowUnknown = false) => {
  if (!allowUnknown)
  {
    return packetSizes;
  }

  const hasUnknownOption = packetSizes.some((option) => isUnknownPacketSize(option?.value || option?.label));
  return hasUnknownOption ? packetSizes : [...packetSizes, UNKNOWN_PACKET_SIZE_OPTION];
};

const AddGRNProductsModal = ({ page_data, openModal, successFunction }) => {

  const dispatch = useDispatch();
  const [productListLoading, setProductListLoading] = useState(true);
  const [product_data, setProductData] = useState([]);
  const [warehousestorageslist, setWarehouseStoragesList] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent_data, setSentData] = useState(page_data);
  const [goodsReceivedProductItems, setGoodsReceivedProductItems] = useState({
    product_id: "",
    product_type: "",
    product: "",
    warehouse_storage_id: "",
    warehouse_storage: "",
    total_capacity_selected_measurement: "",
    total_capacity_in_mt: "",
    warehouse_storage: "",
    packet_size: "",
    product_type_id: "",
    density_weight: ""
  });
  const [productTypeList, setProductTypeList] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [productsList, setProductsList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [packet_sizes, setPacketSizes] = useState([]);
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [error_confirm, setErrorConfirm] = useState(false);

  useEffect(() => {
    if (openModal && page_data)
    {
      // Retrieve Product List
      dispatch(
        employee_dashboard_actions_helper(
          loading_product_list,
          success_product_list,
          fail_product_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_ACTIVE_PRODUCT_LIST,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );

      // Retrieve Warehouse Storage List
      dispatch(
        employee_dashboard_actions_helper(
          loading_retrieve_warehouse_storages_list,
          success_retrieve_warehouse_storages_list,
          fail_retrieve_warehouse_storages_list,
          RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG,
          RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG,
          app_consts.POST,
          RETRIEVE_SPECIFC_BRANCH_STORAGE_LIST_BY_STATUS_ID_API,
          { branch_location_id: page_data?.branch_location?.branch_location_id, warehouse_storage_status_id: app_consts.ACTIVATE_ACCOUNT_ID },
          RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG,
          app_consts.MAP,
          app_consts.BRANCH_STORAGES_TYPES_MAP
        )
      );
    }
    setSentData(page_data);
    setGoodsReceivedProductItems([]);
  }, [openModal, page_data]);

  //Listen to State of Product List
  const product_list = useSelector((state) => state.product_list.product_list);

  useEffect(() => {
    if (product_list.status !== app_consts.IDLE)
    {
      if (product_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
      } else
      {
        setProductListLoading(false);
        if (product_list.status === app_consts.FAIL)
        {
          messageToast(product_list.message, app_consts.FAIL);
        } else if (product_list.status === app_consts.SUCCESS)
        {
          // Remapp Product Types
          const remapped_product_types = product_list.data?.map((product_type) => { return { label: product_type.product_type, value: product_type.product_type_id }; });
          setProductTypeList(remapped_product_types);
          setProductData(product_list.data);
        }
        dispatch(reset_product_list());
      }
    }
  }, [product_list]);


  const warehouse_storages_list = useSelector((state) => state.retrieve_warehouse_storages_list.retrieve_warehouse_storages_list);

  useEffect(() => {
    if (warehouse_storages_list.status !== app_consts.IDLE)
    {
      if (warehouse_storages_list.status === app_consts.LOADING)
      {
        // setLoading(true);
      } else
      {
        // setLoading(false);
        if (warehouse_storages_list.status === app_consts.FAIL)
        {
          messageToast(warehouse_storages_list.message, app_consts.FAIL);
        } else if (warehouse_storages_list.status === app_consts.SUCCESS)
        {
          if (warehouse_storages_list.data?.length === 0)
          {
            messageToast("No Warehouse Storage Sites Found.", app_consts.FAIL);
          }
          else
          {
            setWarehouseStoragesList(warehouse_storages_list.data);
          }
        }
        dispatch(reset_retrieve_warehouse_storages_list());
      }
    }
  }, [warehouse_storages_list]);

  const removeOrderItem = (id) => {
    setGoodsReceivedProductItems(goodsReceivedProductItems.filter(item => item.id !== id));
  };

  const handleWarehouseStorageChange = (value, label) => {
    setFormData({ ...formData, ["warehouse_storage"]: label, ["warehouse_storage_id"]: value, ["product_id"]: "", ["product"]: "", ["product_type"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["product_type_id"]: "", ["packet_size"]: "", density_weight: "", base_weight: "" });
  };

  const handleProductTypeChange = (value, label) => {
    const filtereredData = product_data?.filter((data) => data.product_type_id === value);

    setSelectedProducts(filtereredData[0]?.products);
    // Remapp Product Types
    const remapped_product_types = filtereredData[0]?.products?.map((product) => { return { label: product.product_name, value: product.product_id }; });

    setProductsList(remapped_product_types);

    setFormData({ ...formData, ["product_type"]: label, ["product_type_id"]: value, ["product_id"]: "", ["product"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["packet_size"]: "", density_weight: "", base_weight: "" });
  };

  const handleProductChange = (value, label) => {
    const filtereredData = selectedProducts?.filter((data) => { return data.product_id === value && data.product_type_id === formData?.product_type_id; });

    const packet_sizes = filtereredData[0]?.pum_list?.flatMap(item => item?.uom_details?.map(data => ({ label: data?.packet_size, value: data?.packet_size })) || []) || [];

    setPacketSizes(packet_sizes);

    setFormData({ ...formData, ["product_id"]: value, ["product"]: label, ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["packet_size"]: "", density_weight: "", base_weight: "" });
  };

  const handlePacketSizeChange = (value) => {
    if (isUnknownPacketSize(value))
    {
      setFormData({ ...formData, ["packet_size"]: UNKNOWN_PACKET_SIZE, ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", density_weight: "", base_weight: "" });
      return;
    }

    const filteredProduct = selectedProducts?.filter((data) => { return data.product_id === formData?.product_id && data.product_type_id === formData?.product_type_id; });

    const filtered_measurement_data = filteredProduct[0]?.pum_list?.find(item => item?.uom_details?.some(detail => detail?.packet_size === value))?.uom_details?.find(detail => detail?.packet_size === value);

    setFormData({ ...formData, ["packet_size"]: value, ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", density_weight: filtered_measurement_data?.measurement_in_kilos, base_weight: filtered_measurement_data?.base_weight_in_kilos });
  };

  const handleOnblur = (e) => {
    if (e.target.name === "total_capacity_in_mt")
    {
      if (e.target.value)
      {
        setFormData({ ...formData, ["total_capacity_in_mt"]: parseFloat(e.target.value).toFixed(2) });
      }
      else
      {
        setFormData({ ...formData, ["total_capacity_in_mt"]: "" });
      }
    }
    else
    {
      setFormData({ ...formData, ["total_capacity_in_mt"]: formData?.total_capacity_in_mt ? parseFloat(formData?.total_capacity_in_mt).toFixed(2) : "" });
    }
  };

  const add_products_to_goods_received = () => {
    const unknownPacketSelected = isUnknownPacketSize(formData?.packet_size);

    if (
      !formData?.product_id ||
      !formData?.product_type ||
      !formData?.product ||
      !formData?.warehouse_storage_id ||
      !formData?.warehouse_storage ||
      !formData?.total_capacity_in_mt ||
      !formData?.warehouse_storage ||
      !formData?.packet_size ||
      !formData?.product_type_id ||
      !formData?.total_capacity_selected_measurement ||
      (!unknownPacketSelected && !formData?.density_weight)
    ) return;

    // Check for Duplicates
    const isDuplicate = goodsReceivedProductItems?.find((item) => {
      return item?.product_type_id === formData.product_type_id && item?.product_id === formData.product_id && item?.warehouse_storage_id === formData.warehouse_storage_id && item?.packet_size === formData?.packet_size;
    });

    if (isDuplicate)
    {
      messageToast(`Duplicate Entry of ${formData.product} at Storage ${formData.warehouse_storage}`, app_consts.FAIL);
    }
    else
    {
      setGoodsReceivedProductItems([...goodsReceivedProductItems, { ...formData, product_id: formData?.product_id, product_type: formData?.product_type, product: formData?.product, warehouse_storage_id: formData?.warehouse_storage_id, warehouse_storage: formData?.warehouse_storage, total_capacity_selected_measurement: formData?.total_capacity_selected_measurement, total_capacity_in_mt: formData?.total_capacity_in_mt, warehouse_storage: formData?.warehouse_storage, packet_size: formData?.packet_size, product_type_id: formData?.product_type_id, density_weight: unknownPacketSelected ? "" : formData?.density_weight, base_weight: unknownPacketSelected ? "" : formData?.base_weight, id: Date.now() }]);

      setFormData(initialState);
      setSelectedProducts([]);
      setPacketSizes([]);
    }
  };

  const handleAddProducts = () => {
    setErrorConfirm("");
    const api_data = { goods_received_ref_number: sent_data?.goods_received?.goods_received_ref_number, products: goodsReceivedProductItems };
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_add_goods_received_products,
        success_add_goods_received_products,
        fail_add_goods_received_products,
        CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ERR_MSG,
        CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG,
        app_consts.POST,
        ADD_GRN_PRODUCTS_API,
        api_data,
        CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Reducer Changes
  const add_grn_products_listener = useSelector((state) => state.add_goods_received_products.add_goods_received_products);
  //
  useEffect(() => {
    if (add_grn_products_listener.status !== app_consts.IDLE)
    {
      if (add_grn_products_listener.status === app_consts.LOADING)
      {
        setErrorConfirm("");
      } else
      {
        if (add_grn_products_listener.status === app_consts.FAIL)
        {
          setErrorConfirm(add_grn_products_listener.message);
          messageToast(add_grn_products_listener.message, app_consts.FAIL);
        } else if (add_grn_products_listener.status === app_consts.SUCCESS)
        {
          messageToast(CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction(add_grn_products_listener.data);
        }
        dispatch(reset_add_goods_received_products());
      }
    }
  }, [add_grn_products_listener]);

  const grainProductSelected = isGrainProduct(formData?.product_type, formData?.product);
  const unknownPacketSelected = isUnknownPacketSize(formData?.packet_size);
  const packetSizeOptions = getPacketSizeOptions(packet_sizes, grainProductSelected);
  const canAddProduct = Boolean(
    formData?.product_id &&
    formData?.warehouse_storage_id &&
    formData?.total_capacity_in_mt &&
    formData?.packet_size &&
    formData?.product_type_id &&
    Number(formData?.total_capacity_in_mt) > 0 &&
    formData?.total_capacity_selected_measurement &&
    (unknownPacketSelected || formData?.density_weight)
  );


  return (
    <>
      <div className="card-inner bg-white">
        <Block>
          <BlockHead>
            <BlockTitle tag="h5">Products</BlockTitle>
          </BlockHead>
          {error && (
            <div className="mb-3 w-100">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> {error}{" "}
              </Alert>
            </div>
          )}
          <BlockBetween>
            {
              sent_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status?.toLowerCase() === app_consts.OFFLOADING_GOODS && goodsReceivedProductItems?.length > 0 && (
                <>
                  <Button color="primary"
                    size="sm" onClick={() => setOpenConfirmCancelModal(!openConfirmCancelModal)}>Add Products</Button>
                </>
              )
            }
          </BlockBetween>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              <DataTableRow size="lg"><span className="sub-text">Warehouse Storage</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Product Type</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Base Weight(KGs)</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Density Weight(KGs)</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Packaging Number</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Base Capacity (MT)</span></DataTableRow>
            </DataTableHead>
            {goodsReceivedProductItems.length > 0 &&
              goodsReceivedProductItems.map((item) => (
                <DataTableItem key={item.id}>
                  <DataTableRow><span className="tb-sub">{item?.warehouse_storage || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.product_type || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.product || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.packet_size || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.base_weight || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.density_weight || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.total_capacity_selected_measurement || "0"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.total_capacity_in_mt || "0"}</span></DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <Button color="danger" size="sm" onClick={() => removeOrderItem(item.id)}>Remove</Button>
                  </DataTableRow>
                </DataTableItem>
              ))}
            {/* Add New Order Item */}
            <DataTableItem>
              <DataTableRow>
                <RSelect
                  options={warehousestorageslist}
                  className="w-100"
                  placeholder="Search"
                  id="product_type"
                  onChange={(e) => { handleWarehouseStorageChange(e.value, e.label); }}
                  isDisabled={productListLoading}
                  value={getSelectedOption(formData?.warehouse_storage_id, warehousestorageslist)}
                />
              </DataTableRow>
              <DataTableRow>
                <RSelect
                  options={productTypeList}
                  className="w-100"
                  placeholder="Search"
                  id="product_type"
                  onChange={(e) => { handleProductTypeChange(e.value, e.label); }}
                  isDisabled={!formData?.warehouse_storage_id}
                  value={getSelectedOption(formData?.product_type_id, productTypeList)}
                />
              </DataTableRow>
             <DataTableRow>
              <div style={{ minWidth: "350px" }}>
                <RSelect
                  options={productsList}
                  className="w-100"
                  placeholder="Search"
                  id="product_id"
                  onChange={(e) => {
                    handleProductChange(e.value, e.label);
                  }}
                  isDisabled={!formData?.product_type_id}
                  value={getSelectedOption(formData?.product_id, productsList)}
                />
              </div>
            </DataTableRow>

              <DataTableRow>
                <RSelect
                  options={packetSizeOptions}
                  className="w-100"
                  placeholder="Search"
                  id="packet_size"
                  onChange={(e) => { handlePacketSizeChange(e.value); }}
                  isDisabled={!formData?.product_id}
                  value={getSelectedOption(formData?.packet_size, packetSizeOptions)}
                />
              </DataTableRow>
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    min={0}
                    value={unknownPacketSelected ? "" : formData.base_weight}
                    colSize="10"
                    disabled
                  />
                </Row>
              </DataTableRow>
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    min={0}
                    value={unknownPacketSelected ? "" : formData.density_weight}
                    colSize="10"
                    disabled
                  />
                </Row>
              </DataTableRow>

              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    min={0}
                    value={formData.total_capacity_selected_measurement}
                    colSize="10"
                    handleChange={(e) => {
                      const selected = parseFloat(e.target.value) || 0;

                      if (unknownPacketSelected)
                      {
                        setFormData({
                          ...formData,
                          total_capacity_selected_measurement: selected,
                        });
                        return;
                      }

                      const base = parseFloat(formData.base_weight) || 0;

                      const totalBaseMT = base ? (selected * base) / 1000 : 0;

                      setFormData({
                        ...formData,
                        total_capacity_selected_measurement: selected,
                        total_capacity_in_mt: parseFloat(totalBaseMT)?.toFixed(2),
                      });
                    }}
                    onBlur={handleOnblur}
                    disabled={!formData?.packet_size}
                  />
                </Row>
              </DataTableRow>

              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    min={0}
                    value={formData.total_capacity_in_mt}
                    colSize="10"
                    disabled={!formData?.packet_size}
                    name="total_capacity_in_mt"
                    handleChange={(e) => {
                      const totalMT = parseFloat(e.target.value) || 0;

                      if (unknownPacketSelected)
                      {
                        setFormData({
                          ...formData,
                          total_capacity_in_mt: totalMT,
                        });
                        return;
                      }

                      const base = parseFloat(formData.base_weight) || 0;

                      const selectedMeasurement = base ? (totalMT * 1000) / base : 0;

                      setFormData({
                        ...formData,
                        total_capacity_in_mt: totalMT,
                        total_capacity_selected_measurement: parseFloat(selectedMeasurement)?.toFixed(2),
                      });
                    }}
                    onBlur={handleOnblur}
                  />
                </Row>
              </DataTableRow>
              <DataTableRow>
                <Button color="primary"
                  disabled={loading || !canAddProduct}
                  size="sm" onClick={add_products_to_goods_received}>Add</Button>
              </DataTableRow>
            </DataTableItem>
          </div>
        </Block>
      </div>
      {/* Yes or No Modal */}
      <ModalConfirmCancel
        openModal={openConfirmCancelModal}
        setOpenModal={setOpenConfirmCancelModal}
        modalTitle={`Add Products to GRN ${sent_data?.goods_received?.goods_received_ref_number}`}
        modalDescription={`Are you sure that you want to Add Products to ${sent_data?.goods_received?.goods_received_ref_number}?`}
        buttonConfirm="Confirm"
        buttonCancel="Cancel"
        succFunc={handleAddProducts}
        errAmend={error_confirm}
        setErrAmend={setErrorConfirm}
      />
    </>
  );
};

export default AddGRNProductsModal;
